import { arrowRight } from '@harbor/elements/icons';
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFetchEscalationRequests } from '../../../hooks/escalation-request-hooks';
import { useFetchOpportunityProducts } from '../../../hooks/opportunity-hooks';
import { ApprovalRequestStatusLevel } from '../../../types/approval-request';
import StbButton from '../../security-toolbox-ui/StbButton';
import OpportunityEscalationModal from './OpportunityEscalationModal';


const OpportunityEscalationRequestor: React.FC = () => {
  const { id: opportunityId } = useParams();

  const { data: opportunityProducts, isLoading: loadingOpportunityProducts } = useFetchOpportunityProducts(opportunityId, {}, { enabled: !!opportunityId });
  const { data: escalationRequests, isLoading: loadingEscalationRequests } = useFetchEscalationRequests(opportunityId, {}, { enabled: !!opportunityId });

  const [requestModalOpen, setRequestModalOpen] = useState(false);

  const escalated = useMemo(() => (escalationRequests ?? [])
    .filter(req => req !== null &&
      req?.status?.status !== ApprovalRequestStatusLevel.Cancelled &&
      req?.status?.status !== ApprovalRequestStatusLevel.Denied
    )
    .map(req => req?.product?.id
  ), [escalationRequests]);

  const products = useMemo(() => (opportunityProducts ?? [])
    .filter(p => p?.vendor?.is_cisco && !escalated.includes(p?.id)
  ), [opportunityProducts, escalated]);

  const escalationDisabled = useMemo(() => {
    if (
      loadingOpportunityProducts ||
      loadingEscalationRequests ||
      products.length === 0
    ) return true

    return products.length === 0;
  }, [products, loadingOpportunityProducts, loadingEscalationRequests]);

  return (
    <>
      <StbButton
        sentiment="warning"
        icon={arrowRight}
        onClick={() => setRequestModalOpen(true)}
        disabled={escalationDisabled}
      >Request Assistance</StbButton>

      <OpportunityEscalationModal open={requestModalOpen} setOpen={setRequestModalOpen} availableProducts={products}/>
    </>
  )
}

export default OpportunityEscalationRequestor;